module.exports = __webpack_public_path__ + "img/img18.f58578ff.svg";